module.exports = __webpack_public_path__ + "static/media/accordionOpen.d2320e39.svg";